export const getOrientationMode = () => {
  switch(window.orientation) {
  case -90: case 90:
    return true;
  default:
    return false;
  }
}